define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"Quality/NewFromTestRunTemplate"
], function(declare,{ routerStore },NewFromTestRunTemplate) {

	return declare(NewFromTestRunTemplate, {
		bColorContext: true,

        /**
         * @override
         * Product is actually higher up because this is from Color Material
         * Also need to set the color explicitly
         */
		onCreatePopupParams: function(params) {
            params = params || {};
            params.testRunColor = this.getParent().$URL;
            params.testRunContextNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");
            params.bCanCreateMultipleTestRuns = true;
        }
	});
});